import { BaseModel } from './BaseModel';
import Post from './Post';
import Section from './Section';

export class PostSchedule extends BaseModel {
  static get entity() {
    return 'post-schedules';
  }

  static fields() {
    return {
      id: this.attr(null),
      published_at: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      post_id: this.attr(null),
      post: this.belongsTo(Post, 'post_id'),
      section_id: this.attr(null),
      section: this.belongsTo(Section, 'section_id'),
      required_review: this.boolean(false),
      reviewed_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      findAll(params = {}) {
        return this.get(`post-schedules`, {
          params
        });
      },

      findForTeacher(sectionId, params = {}) {
        return this.get(`sections/${sectionId}/post-schedules/teaching-team`, {
          params
        });
      },

      findForLearner(sectionId, params = {}) {
        return this.get(`sections/${sectionId}/post-schedules/learner`, {
          params
        });
      },

      update(id, body) {
        return this.put(`post-schedules/${id}`, body);
      },

      markAsReviewed(id) {
        return this.put(`post-schedules/${id}`, {
          required_review: false,
          reviewed_at: Date.now()
        });
      }
    }
  };
}

export default PostSchedule;
